import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { getAllProducts } from 'src/store/modules/games/actions'
import { enabledGamesSelector } from 'src/store/modules/games/disabledContentSelectors'
import { allGamesSelector, allGamesLoadingSelector } from 'src/store/modules/games/selectors'

/**
 *
 * @param withFetch needs for avoiding of concurrent requests at the same time
 * @returns
 */
export default function useGames(withFetch = true) {
  const dispatch = useAppDispatch()
  const allGames = useAppSelector(allGamesSelector)
  const allVisibleGames = useAppSelector(enabledGamesSelector)
  const allGamesLoading = useAppSelector(allGamesLoadingSelector)
  const shouldLoad = withFetch && !allGamesLoading && !allGames.length

  useEffect(() => {
    if (shouldLoad) {
      dispatch(getAllProducts())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { allGames, allVisibleGames }
}
